import { i18n } from '@atlas-frontend/i18n';
import { Dayjs } from 'dayjs';
import {
  DATE_FORMAT,
  getDatePeriodFromString,
  getDayjs,
  MAX_TIMESTAMP,
  MIN_TIMESTAMP,
} from './dateUtils';
import { PeriodArray, PeriodStringArray } from '../types';

export const sortString = (a: string | null, b: string | null) =>
  (a || '').localeCompare(b || '', i18n.language);

export const sortStringLower = (a: string | null, b: string | null) =>
  (a?.toLowerCase() || '').localeCompare(b?.toLowerCase() || '', i18n.language);

export const sortNumber = (a: number | null, b: number | null) => {
  a = a !== null ? a : Number.NEGATIVE_INFINITY;
  b = b !== null ? b : Number.NEGATIVE_INFINITY;
  return a - b;
};

export const sortDate = (
  a: Dayjs | string | null,
  b: Dayjs | string | null,
  max: boolean,
) => {
  const emptyReplace = getDayjs(max ? MAX_TIMESTAMP : MIN_TIMESTAMP)!;
  const dayjsA = getDayjs(a) || emptyReplace;
  const dayjsB = getDayjs(b) || emptyReplace;
  return dayjsA.isBefore(dayjsB) ? -1 : dayjsA.isAfter(dayjsB) ? 1 : 0;
};

export const sortPeriod = (
  a?: PeriodArray | PeriodStringArray,
  b?: PeriodArray | PeriodStringArray,
) => {
  const fromResult = sortDate(a ? a[0] : null, b ? b[0] : null, false);
  return fromResult === 0
    ? sortDate(a ? a[1] : null, b ? b[1] : null, true)
    : fromResult;
};

export const sortPeriodString = (a: string, b: string) =>
  sortPeriod(
    getDatePeriodFromString(a, DATE_FORMAT),
    getDatePeriodFromString(b, DATE_FORMAT),
  );

export const compareIsoDates = (a: string | null, b: string | null) =>
  (b ? new Date(b).valueOf() : MIN_TIMESTAMP) -
  (a ? new Date(a).valueOf() : MAX_TIMESTAMP);

export const stringToBoolean = (val: string | null): boolean | null => {
  switch (val) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return null;
  }
};
